import React from 'react';
import { Link } from "react-router-dom";
import DateSince from '../../../components/Date';
import Avatar from '../../../components/Avatar';
import createLink from "../../../../libs/createLink";
import DraftContentExcerpt from "../../../components/editor/DraftContentExcerpt";
import {isNoFollowProfil} from "../../../../libs/helper";

const StatusCard = (props) => {
    let relLinkProfil = isNoFollowProfil(props.owner) ? { rel: "nofollow" } : {};

    return (
        <div className="status-card">
            <div className="topline">
                <Link to={createLink("userProfile", props.owner)} {...relLinkProfil}>
                    <Avatar className="user-thumb" avatar={props.owner.profile.avatar} alt=""
                            gender={props.owner.profile.gender}/>
                </Link>
                <div className="username">
                    <Link to={createLink("userProfile", props.owner)} {...relLinkProfil}>
                        {props.owner.username}&nbsp;
                    </Link>
                </div>
            </div>
            <div className="wrapper">
                <div className="title">
                    <Link to={createLink("userProfile", props.owner)} {...relLinkProfil} className={"grey"}>
                        <DraftContentExcerpt contentRaw={props.contentRaw} maxLine={'2'} />
                    </Link>
                </div>
                <div className="infos">
                    <span className="date">
                        <DateSince
                            date={props.createdAt}
                            prefix={true}
                            currentFormat={true}
                        />
                    </span>
                </div>
            </div>
        </div>
    )
};

StatusCard.defaultProps = {
    content: "",
    owner: {
        _id: 0,
        gender: "",
        slug: '',
        username: '',
        profile: {
            avatar: "",
            gender: 3
        }
    },
    authorName: ""
};

export default StatusCard;
